import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from '@/utils/constants'

import { UserRegistrationPayload } from '@/types/user/account'

export const register = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.REGISTER}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = UserRegistrationPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json()
    },
)
